import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { DatePipe } from "@angular/common";
import Swal from "sweetalert2";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesDates } from '../../../models/messages';
import { ProformaService } from '../../../services/operaciones/proforma/proforma.service';
import { Proforma } from '../../../models/Proforma';
import { environment } from 'environments/environment';
export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-nueva-operacion',
  templateUrl: './nueva-operacion.component.html',
  styleUrls: ['./nueva-operacion.component.scss'],
  providers: [MessagesTitles,MessagesGeneral,MessagesDates,Proforma,
    DatePipe,  
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class NuevaOperacionComponent implements OnInit {
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_id_soles=environment.ID_GUIA_SOLES;
  
  operaciones : any = [];
  estado ="P";
  idProv ="" ;
  idAdq ="";
  value = '';
  idOperacionSelect = "";
  Proforma:Proforma;
  flag:boolean=false;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  
  pageSizeOptions = [15,25,35,55,105,205];
  docNegociables:any = [];
  loading:boolean=false;
  displayedColumns: string[] = 
  ['checked','idProforma','Fecha_Proforma','pRazonSocial',
  'aRazonSocial',
  'Fecha_Desembolso',
  'Mon',
  'VNPP',
  'Adelanto_porcentaje',
  'Factoring_SUNAT_Importe',
  'Desembolso_Importe',
  'Remanente_Importe',
  'Tasa_Mensual'];

  dataSource :any;
  constructor(public proformaModel: Proforma, private proformaService:ProformaService) {
  }

  applyFilter(filterValue: string) {
    if(null != this.dataSource){
       this.dataSource.filter = filterValue.trim().toLowerCase();
    }
  }

  ngOnInit() {
    this.ListadoOperacionesFiltros()
  }
  
  ListadoOperacionesFiltros() {
    this.loading = true;   
    this.proformaService.obtenerProformaOperacion()                                            
    .subscribe(
        res => {       
            this.operaciones = res;
            this.dataSource = new MatTableDataSource(this.operaciones);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
            this.loading = false;
        } , err =>{
            Swal.fire({
              title: "Registrar tipo de cambio",
              text: "Coordinar con el área de contabilidad",
              allowOutsideClick: true,
              heightAuto: false
            });        
          this.loading = false;
        }
    )
  }

  openForm(variable){
    this.proformaModel.idProforma = variable.idProforma;
    this.proformaModel.idProveedor = variable.idProveedor;
    this.proformaModel.idFactor = variable.idFactor;
    this.proformaModel.NombreProveedor = variable.pRazonSocial;
    this.proformaModel.NombreAdquirente = variable.aRazonSocial;
    this.proformaModel.Moneda = variable.Moneda;
    this.proformaModel.Fecha_Desembolso = variable.Fecha_Desembolso;
    this.proformaModel.Adelanto_porcentaje = variable.Adelanto_porcentaje * 100;
    this.proformaModel.TEM = variable.Tasa_Mensual * 100;
    this.proformaModel.Tipo_Servicio = variable.Tipo_Servicio;
    this.proformaModel.Porcentaje_Interes_Adquirente = variable.Porcentaje_Interes_Adquirente;
    this.flag = true;
  }

  CerrarVentana(){
    this.flag = false;
  }
}
